import { navigate } from '@reach/router';
import React, { useContext, useEffect } from 'react';
import { AccountContext, PleaseSelectAccount } from '../../context/account';
import { NotebookProvider, SELECTED_NOTEBOOK_ID } from '../../context/NotebookContext';
import { TimeProvider } from '../../context/time';
import client from '../../lib/client';
import { notebooksQuery } from '../../queries/notebooks';
import {
  NotebooksQuery,
  NotebooksQueryVariables
} from '../../queries/__generated__/NotebooksQuery';

const PleaseSelectNotebookForNote: React.FC = ({ children }) => {
  const accountContext = useContext(AccountContext);
  const selectedNotebookId = localStorage.getItem(SELECTED_NOTEBOOK_ID) || '';

  async function selectNotebook() {
    if (accountContext.selectedAccountId) {
      await client
        .query<NotebooksQuery, NotebooksQueryVariables>({
          query: notebooksQuery,
          variables: { input: { accountId: accountContext.selectedAccountId } }
        })
        .then(({ data }) => {
          const { notebooks } = data;
          if (notebooks && notebooks.length > 0) {
            localStorage.setItem(SELECTED_NOTEBOOK_ID, notebooks[0].id);
          } else {
            navigate('/');
          }
        });
    }
  }

  useEffect(() => {
    if (!selectedNotebookId) {
      selectNotebook();
    }
  }, []);

  return (
    <PleaseSelectAccount>
      <NotebookProvider initialNotebookId={selectedNotebookId}>
        <TimeProvider>{children}</TimeProvider>
      </NotebookProvider>
    </PleaseSelectAccount>
  );
};

export default PleaseSelectNotebookForNote;
